import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  title = 'app';
}



// WEBPACK FOOTER //
// /app/frontend/src/app/app.component.ts